(() => {
  if (window.__nutriscoRegionAvailabilityInit) return;
  window.__nutriscoRegionAvailabilityInit = true;

  const STORAGE_REGION_KEY = 'region';
  const HIDDEN_CLASS = 'nutrisco-region-hidden';
  const UNAVAILABLE_BTN_CLASS = 'nutrisco-region-unavailable-btn';
  const UNAVAILABLE_BTN_TEXT = 'PRODUCTO NO DISPONIBLE EN TU COMUNA';
  const COLLECTION_EMPTY_ID = 'nutrisco-region-collection-empty';
  const STYLE_ID = 'nutrisco-region-availability-style';
  const CART_ROUTE = (window.theme && theme.routes && theme.routes.cart) ? theme.routes.cart : '/cart';
  const CART_JSON_URL = `${CART_ROUTE}.js`;
  const CART_UPDATE_URL = `${CART_ROUTE}/update.js`;

  let collectionObserver = null;
  let collectionObserverRoot = null;
  let searchObserver = null;
  let searchObserverRoot = null;
  const predictiveSearchObservers = new Map();
  let cartCleanupInProgress = false;
  const restrictedTagsByHandleCache = new Map();
  let rafId = 0;
  let pendingRegion;

  // Rules loaded from the header section JSON
  let regionRules = null;

  function loadRegionRules() {
    if (regionRules) return regionRules;

    const el = document.getElementById('nutrisco-region-product-rules');
    if (!el) {
      regionRules = {};
      return regionRules;
    }

    try {
      regionRules = JSON.parse(el.textContent);
    } catch (e) {
      regionRules = {};
    }

    // Normalize: uppercase region codes, lowercase tag keys
    const normalized = {};
    for (const tag in regionRules) {
      const regions = Array.isArray(regionRules[tag]) ? regionRules[tag] : [];
      normalized[tag.toLowerCase().trim()] = regions.map((r) => r.toUpperCase().trim());
    }
    regionRules = normalized;
    return regionRules;
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `.${HIDDEN_CLASS} { display: none !important; } .${UNAVAILABLE_BTN_CLASS} { opacity: 0.6; cursor: not-allowed; pointer-events: none; }`;
    document.head.appendChild(style);
  }

  function getStoredRegion() {
    try {
      return localStorage.getItem(STORAGE_REGION_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function isProductRestricted(productTags, region) {
    if (!region) return false;

    const rules = loadRegionRules();
    const ruleKeys = Object.keys(rules);
    if (ruleKeys.length === 0) return false;

    const upperRegion = region.toUpperCase().trim();
    const tags = typeof productTags === 'string'
      ? productTags.split(',').map((t) => t.trim().toLowerCase())
      : [];

    for (let i = 0; i < ruleKeys.length; i++) {
      const ruleTag = ruleKeys[i];
      if (tags.includes(ruleTag)) {
        const allowedRegions = rules[ruleTag];
        if (!allowedRegions.includes(upperRegion)) {
          return true;
        }
      }
    }

    return false;
  }

  function setHidden(element, shouldHide) {
    if (!element) return;
    element.classList.toggle(HIDDEN_CLASS, shouldHide);
  }

  function applyMenuRestriction() {
    const region = getStoredRegion().toUpperCase();
    const items = document.querySelectorAll('[data-region-visibility]');

    items.forEach((item) => {
      const allowed = item.getAttribute('data-region-visibility')
        .split(',')
        .map((r) => r.trim().toUpperCase());
      const shouldHide = region ? !allowed.includes(region) : false;
      setHidden(item, shouldHide);
    });
  }

  function ensureCollectionEmptyMessage(container) {
    let msg = container.querySelector(`#${COLLECTION_EMPTY_ID}`);
    if (msg) return msg;

    msg = document.createElement('div');
    msg.id = COLLECTION_EMPTY_ID;
    msg.className = `nutrisco-collection-empty ${HIDDEN_CLASS}`;
    msg.innerHTML = '<h2 class="nutrisco-collection-empty__title">No hay productos disponibles en esta colección</h2>'
      + '<a href="/" class="btn btn--primary">VOLVER AL HOME</a>';
    container.appendChild(msg);
    return msg;
  }

  function applyCollectionEmptyState(collectionRoot) {
    if (!collectionRoot) return;

    const cards = collectionRoot.querySelectorAll('product-card[data-product-tags]');
    if (cards.length === 0) return;

    const allHidden = Array.from(cards).every((card) => {
      const target = card.closest('.js-pagination-result') || card;
      return target.classList.contains(HIDDEN_CLASS);
    });

    const container = collectionRoot.querySelector('.container') || collectionRoot;
    const toolbar = collectionRoot.querySelector('products-toolbar');
    const filtersPanel = collectionRoot.querySelector('.main-products-grid__filters');
    const pagination = collectionRoot.querySelector('custom-pagination');

    const emptyMsg = ensureCollectionEmptyMessage(container);

    setHidden(emptyMsg, !allHidden);
    if (toolbar) setHidden(toolbar, allHidden);
    if (filtersPanel) setHidden(filtersPanel, allHidden);
    if (pagination) {
      const grid = pagination.querySelector('ul[role="list"]');
      if (grid) setHidden(grid, allHidden);
      const paginationNav = pagination.querySelector('.pagination');
      if (paginationNav) setHidden(paginationNav, allHidden);
    }
  }

  function applyCardRestrictions(region) {
    const allCards = document.querySelectorAll('product-card[data-product-tags]');

    allCards.forEach((card) => {
      const tags = card.getAttribute('data-product-tags');
      const restricted = isProductRestricted(tags, region);
      const isCollection = card.closest('.cc-collection-products');
      const isSearch = card.closest('.cc-main-search');
      const isFeatured = card.closest('.products-grid-container') || card.closest('.fcwi__products');

      if (isCollection || isSearch) {
        const target = card.closest('.js-pagination-result') || card;
        setHidden(target, restricted);
      } else if (isFeatured) {
        const quickAdd = card.querySelector('.card__quick-add');
        setHidden(quickAdd, restricted);
      }
    });

    const collectionRoot = document.querySelector('.cc-collection-products');
    applyCollectionEmptyState(collectionRoot);
  }

  function applyPredictiveSearchRestriction(region) {
    const items = document.querySelectorAll('.predictive-search__item[data-product-tags]');

    items.forEach((item) => {
      const tags = item.getAttribute('data-product-tags');
      const restricted = isProductRestricted(tags, region);
      setHidden(item, restricted);
    });

    // Hide the "Productos" tab + panel if all product items are hidden
    document.querySelectorAll('.predictive-search__tabpanel').forEach((panel) => {
      const allItems = panel.querySelectorAll('.predictive-search__item:not(.js-submit)');
      if (allItems.length === 0) return;

      const visibleItems = Array.from(allItems).filter(
        (item) => !item.classList.contains(HIDDEN_CLASS)
      );

      const tabId = panel.getAttribute('aria-labelledby');
      const tab = tabId ? document.getElementById(tabId) : null;
      const allHidden = visibleItems.length === 0;

      setHidden(panel, allHidden);
      if (tab) setHidden(tab, allHidden);
    });
  }

  function ensureUnavailableButton(buyButtonsBlock) {
    let btn = buyButtonsBlock.querySelector(`.${UNAVAILABLE_BTN_CLASS}`);
    if (btn) return btn;

    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = `${UNAVAILABLE_BTN_CLASS} btn btn--primary w-full`;
    btn.disabled = true;
    btn.textContent = UNAVAILABLE_BTN_TEXT;
    buyButtonsBlock.appendChild(btn);
    return btn;
  }

  function applyProductPageRestriction(region) {
    const productElements = document.querySelectorAll('.product.js-product[data-product-tags]');
    const stickyAtcPanels = document.querySelectorAll('[data-region-sticky-atc-panel][data-product-tags]');

    productElements.forEach((productRoot) => {
      const tags = productRoot.getAttribute('data-product-tags');
      const restricted = isProductRestricted(tags, region);

      const buyButtonsBlocks = productRoot.querySelectorAll('[data-region-buy-buttons-block]');
      buyButtonsBlocks.forEach((block) => {
        const productForms = block.querySelectorAll('product-form');
        productForms.forEach((form) => setHidden(form, restricted));

        const btn = ensureUnavailableButton(block);
        setHidden(btn, !restricted);
      });

      const bisButton = productRoot.querySelector('.osf-ext-button');
      if (bisButton) setHidden(bisButton, restricted);
    });

    stickyAtcPanels.forEach((panel) => {
      const tags = panel.getAttribute('data-product-tags');
      const restricted = isProductRestricted(tags, region);
      setHidden(panel, restricted);
    });
  }

  function applyRestrictions(region) {
    const activeRegion = typeof region === 'string' ? region : getStoredRegion();

    applyMenuRestriction();
    applyCardRestrictions(activeRegion);
    applyPredictiveSearchRestriction(activeRegion);
    applyProductPageRestriction(activeRegion);
  }

  function getProductJsonUrl(handle) {
    return `/products/${handle}.js`;
  }

  async function hasRestrictedTagsHandle(handle) {
    if (!handle) return false;
    if (restrictedTagsByHandleCache.has(handle)) return restrictedTagsByHandleCache.get(handle);

    const rules = loadRegionRules();
    const ruleKeys = Object.keys(rules);
    if (ruleKeys.length === 0) {
      restrictedTagsByHandleCache.set(handle, false);
      return false;
    }

    try {
      const response = await fetch(getProductJsonUrl(handle), {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        restrictedTagsByHandleCache.set(handle, false);
        return false;
      }

      const product = await response.json();
      const tags = Array.isArray(product.tags)
        ? product.tags.map((t) => t.toLowerCase().trim())
        : typeof product.tags === 'string'
          ? product.tags.split(',').map((t) => t.toLowerCase().trim())
          : [];

      const hasRestricted = tags.some((tag) => ruleKeys.includes(tag));
      restrictedTagsByHandleCache.set(handle, hasRestricted);
      return hasRestricted;
    } catch (error) {
      restrictedTagsByHandleCache.set(handle, false);
      return false;
    }
  }

  async function getRestrictedCartItemKeys(cartItems, region) {
    const rules = loadRegionRules();
    const ruleKeys = Object.keys(rules);
    if (ruleKeys.length === 0) return [];

    const upperRegion = region.toUpperCase().trim();

    const keys = await Promise.all(
      cartItems.map(async (item) => {
        const hasRestricted = await hasRestrictedTagsHandle(item.handle);
        if (!hasRestricted) return null;

        // Re-fetch to check specific tags against region
        try {
          const response = await fetch(getProductJsonUrl(item.handle), {
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) return null;
          const product = await response.json();
          const tags = Array.isArray(product.tags)
            ? product.tags.map((t) => t.toLowerCase().trim())
            : typeof product.tags === 'string'
              ? product.tags.split(',').map((t) => t.toLowerCase().trim())
              : [];

          for (let i = 0; i < ruleKeys.length; i++) {
            if (tags.includes(ruleKeys[i]) && !rules[ruleKeys[i]].includes(upperRegion)) {
              return item.key;
            }
          }
          return null;
        } catch (e) {
          return null;
        }
      })
    );

    return keys.filter(Boolean);
  }

  async function removeRestrictedItemsFromCart(region) {
    if (!region || cartCleanupInProgress) return;

    const rules = loadRegionRules();
    if (Object.keys(rules).length === 0) return;

    cartCleanupInProgress = true;

    try {
      const cartResponse = await fetch(CART_JSON_URL, {
        headers: { Accept: 'application/json' }
      });
      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();
      if (!cart.items || cart.items.length === 0) return;

      const restrictedKeys = await getRestrictedCartItemKeys(cart.items, region);
      if (restrictedKeys.length === 0) return;

      const updates = {};
      restrictedKeys.forEach((key) => {
        updates[key] = 0;
      });

      const updateResponse = await fetch(CART_UPDATE_URL, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!updateResponse.ok) return;

      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));

      document.querySelectorAll('cart-items').forEach((cartItemsEl) => {
        if (typeof cartItemsEl.refreshCartItems === 'function') {
          cartItemsEl.refreshCartItems();
        }
      });
    } catch (error) {
      // Silent fail
    } finally {
      cartCleanupInProgress = false;
    }
  }

  function scheduleApply(region) {
    pendingRegion = region;

    if (rafId) return;

    rafId = window.requestAnimationFrame(() => {
      rafId = 0;
      applyRestrictions(pendingRegion);
      pendingRegion = undefined;
    });
  }

  function setupCollectionObserver() {
    const collectionRoot = document.querySelector('.cc-collection-products');

    if (!collectionRoot) {
      if (collectionObserver) {
        collectionObserver.disconnect();
        collectionObserver = null;
        collectionObserverRoot = null;
      }
      return;
    }

    if (collectionObserver && collectionObserverRoot === collectionRoot) return;

    if (collectionObserver) {
      collectionObserver.disconnect();
    }

    collectionObserver = new MutationObserver(() => {
      scheduleApply();
    });
    collectionObserver.observe(collectionRoot, { childList: true, subtree: true });
    collectionObserverRoot = collectionRoot;
  }

  function setupSearchObserver() {
    const searchRoot = document.querySelector('.cc-main-search');

    if (!searchRoot) {
      if (searchObserver) {
        searchObserver.disconnect();
        searchObserver = null;
        searchObserverRoot = null;
      }
      return;
    }

    if (searchObserver && searchObserverRoot === searchRoot) return;

    if (searchObserver) {
      searchObserver.disconnect();
    }

    searchObserver = new MutationObserver(() => {
      scheduleApply();
    });
    searchObserver.observe(searchRoot, { childList: true, subtree: true });
    searchObserverRoot = searchRoot;
  }

  function setupPredictiveSearchObserver() {
    const predictiveRoots = document.querySelectorAll('predictive-search');

    predictiveRoots.forEach((root) => {
      const resultsContainer = root.querySelector('.js-search-results');
      if (!resultsContainer) return;
      if (predictiveSearchObservers.has(resultsContainer)) return;

      const observer = new MutationObserver(() => {
        scheduleApply();
      });
      observer.observe(resultsContainer, { childList: true, subtree: true });
      predictiveSearchObservers.set(resultsContainer, observer);
    });
  }

  function init() {
    injectStyles();
    loadRegionRules();
    setupCollectionObserver();
    setupSearchObserver();
    setupPredictiveSearchObserver();
    applyRestrictions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('nutrisco:comuna-change', (event) => {
    const detail = event.detail || {};
    setupCollectionObserver();
    setupSearchObserver();
    setupPredictiveSearchObserver();
    scheduleApply(detail.region);
    removeRestrictedItemsFromCart(detail.region);
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_REGION_KEY) return;

    setupCollectionObserver();
    setupSearchObserver();
    setupPredictiveSearchObserver();
    scheduleApply(event.newValue || '');
    removeRestrictedItemsFromCart(event.newValue || '');
  });

  document.addEventListener('shopify:section:load', () => {
    regionRules = null;
    loadRegionRules();
    setupCollectionObserver();
    setupSearchObserver();
    setupPredictiveSearchObserver();
    scheduleApply();
  });
})();
